import { render, staticRenderFns } from "./Champions.vue?vue&type=template&id=258bb81c&scoped=true&"
import script from "./Champions.vue?vue&type=script&lang=js&"
export * from "./Champions.vue?vue&type=script&lang=js&"
import style0 from "./Champions.vue?vue&type=style&index=0&id=258bb81c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "258bb81c",
  null
  
)

export default component.exports